import { useDeviceType } from '@cian/ui-kit';
import { useAppDispatch } from './useAppDispatch';
import { useCallback } from 'react';
import { setModalSource, setModalStatus } from 'shared/common/slices';
import { EModalSource, EModalStatus } from 'shared/common/types/modal';
import { clickSellerOpenModal } from 'shared/landingSeller/components/tracking';
import { useApplicationContext } from 'shared/common/utils/applicationContext';
import { EPageName } from '../constants/pages';
import { clickBuyerOpenModal } from '../../landingBuyer/utils/tracking';

export const useWithModalForm = () => {
  const device = useDeviceType();

  const { custom } = useApplicationContext();
  const isSellerLanding = custom.pageName === EPageName.LandingSeller;
  const clickOpenModal = isSellerLanding ? clickSellerOpenModal : clickBuyerOpenModal;

  const dispatch = useAppDispatch();

  const handleOpenModal = useCallback(
    (label: EModalSource) => {
      dispatch(setModalStatus(EModalStatus.Open));
      dispatch(setModalSource(label as EModalSource));

      clickOpenModal(label, custom);
    },
    [custom.cianUserId, custom.source, dispatch],
  );

  return { handleOpenModal, device };
};
